module.exports = __webpack_public_path__ + "media/images/flags/16/Syria-0e2a446998bead9e8007cfe159dc0046.png";